import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
// import './components/assets/style.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import axios from "axios";
axios.defaults.baseURL = process.env.REACT_APP_BASE_URL;

// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>
// );

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// 1. 动态读取环境变量 (本地是 localhost，线上是 https://...)
axios.defaults.baseURL = process.env.REACT_APP_BASE_URL;

// 2. 请求拦截器：像“安检员”一样，给每个发给后端的请求自动贴上 Token
axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("user_token"); // 从本地取出你登录时存的 Token
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`; // 自动贴在 Header 上
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 3. 响应拦截器：专门对付后端退回来的报错 (比如 401 没登录/过期)
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      alert("您的登录已过期，请重新登录！");
      localStorage.removeItem("user_token");
      sessionStorage.setItem("authenticated", "false");
      window.location.href = "/login"; // 强制踢回登录页
    }
    return Promise.reject(error);
  }
);
// ==========================================

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
